import type { ICGG2Report } from '@fortem-monorepo/web-sdk'

/** Headline pct rows store fractions; other percentage columns use percentage points. */
export const getGuidelineValueScale = (
  guideline: Pick<ICGG2Report.GuidelineResult['guideline'], 'table' | 'value_column' | 'threshold_type'>,
  row: Record<string, unknown>,
) =>
  guideline.table === 'summary.headline' &&
  guideline.value_column === 'value' &&
  guideline.threshold_type === 'percentage' &&
  row.unit === 'pct'
    ? 100
    : 1

/** Plot evaluated values in the same units as the saved threshold labels. */
export const getGuidelineIndicatorValues = (
  guideline: Parameters<typeof getGuidelineValueScale>[0],
  rows: ICGG2Report.GuidelineEvaluatedRow[],
  aggregate: ICGG2Report.GuidelineAggregateEvaluation | null,
): number[] => {
  const values = rows.flatMap(({ row, result }) =>
    result?.value === null || result?.value === undefined
      ? []
      : [result.value * getGuidelineValueScale(guideline, row)],
  )

  if (aggregate?.result.value !== null && aggregate?.result.value !== undefined) {
    values.push(aggregate.result.value * getGuidelineValueScale(guideline, rows[0]?.row ?? {}))
  }

  return values
}
